import React from 'react'
import { useTranslation } from 'react-i18next'
import ShowAssurances from '../components/Assurances/ShowAssurances'

const Assurances:React.FC = () => {
  const { t } = useTranslation()
  return (
    <div className='mt-20'>
      <h1 className='text-center text-3xl'>{t("Assurances")}</h1>
      <ShowAssurances />
    </div>
  )
}

export default Assurances